define('components/photoset/layouts/fitRow/layout', [
    'components/photoset/complexNumber',
    'components/photoset/layouts/fitRow/row'
], function (ComplexNumber, Row) {
    function Layout(jsonLayout) {
        this.width = jsonLayout.width;
        this.items = jsonLayout.items;

        this.noUpscale = jsonLayout.noUpscale;
        this.ignoreOrder = jsonLayout.ignoreOrder;

        this.minColumnsCount = ko.pureComputed(this._getMinColumnsCount, this).extend({ deferred: true });
        this.targetColumnsCount = jsonLayout.columnsCount;
        this.columnsCount = ko.pureComputed(this._getColumnsCount, this).extend({ deferred: true });

        this.offset = jsonLayout.offset;
        this.expand = jsonLayout.expand;

        this.minWidth = ko.pureComputed(function () { return this.columnsCount() * 0.85 }, this);
        this.maxWidth = ko.pureComputed(function () { return this.columnsCount() * 1.25 }, this);

        this.rows = ko.pureComputed(this._getRows, this).extend({ deferred: true });
    }

    Layout.prototype.apply = function () {
        var rows = this.rows(),
            offset = this.offset();

        ko.ignoreDependencies(function () {
            _(rows).reduce(function (rowOffset, row, rowIdx) {
                var items = row.items();

                var rowWidth = row.relWidth(),
                    totalOffset = offset * (items.length - 1);

                _(items).reduce(function (columnOffset, item, colIdx) {
                    var ratio = item.relWidth() / rowWidth;

                    item.top(rowOffset);
                    item.left(columnOffset);
                    item.width(new ComplexNumber(ratio * 100, -totalOffset * ratio));
                    item.isVisible(row.isVisible);
                    item.rowIdx(rowIdx);
                    item.colIdx(colIdx);

                    return columnOffset.add(item.width()).add(0, offset);
                }, new ComplexNumber(), this);

                return rowOffset.add(row.height()).add(0, offset);
            }, new ComplexNumber(), this);
        }, this);
    };

    Layout.prototype._getMinColumnsCount = function () {
        if (this.noUpscale() && this.width() > 0 && this.items().length > 0) {
            var imageSizes = _(this.items()).map(function (item) { return item.absHeight() }),
                minColumnWidth = _(imageSizes).min();

            if (minColumnWidth > 0)
                return Math.ceil(this.width() / minColumnWidth);
        }

        return 1;
    };

    Layout.prototype._getColumnsCount = function () {
        return _([this.targetColumnsCount(), this.minColumnsCount()]).max();
    };

    Layout.prototype._getRows = function () {
        var rows = [];

        var toProcess = _(this.items()).clone(),
            nextItem;

        _(this.items()).invoke('absWidth');
        _(this.items()).invoke('absHeight');

        while ((nextItem = toProcess.shift()) !== undefined) {
            var row = new Row({
                items: [nextItem],
                offset: this.offset,
                minRelWidth: this.minWidth,
                expand: this.expand
            });

            rows.push(row);

            this._fillRow(row, toProcess);
        }

        return rows;
    };

    Layout.prototype._fillRow = function (row, other) {
        ko.ignoreDependencies(function (maxWidth, minWidth, ignoreOrder) {
            var availableWidth = maxWidth - row.realRelWidth();

            if (ignoreOrder && row.realRelWidth() > minWidth)
                other = _(other).sortBy(function (item) { return -item.relWidth() });

            var idx = _(other).findIndex(function (item) { return availableWidth > item.relWidth() });

            if (idx !== -1) {
                row.append(other[idx]);
                other.splice(idx, 1);

                if (row.realRelWidth() < minWidth)
                    this._fillRow(row, other);
            }
        }, this, [this.maxWidth(), this.minWidth(), this.ignoreOrder(), this.expand()]);
    };

    return Layout;
});